import React from 'react';
import PropTypes from 'prop-types';
import HomeIcon from '@material-ui/icons/Home';
import WorkIcon from '@material-ui/icons/Work';
import GroupIcon from '@material-ui/icons/Group';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import DescriptionIcon from '@material-ui/icons/Description';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import AttachFileOutlinedIcon from '@material-ui/icons/AttachFileOutlined';
import MapIcon from '@material-ui/icons/Map';
import RoomIcon from '@material-ui/icons/Room';
import PersonIcon from '@material-ui/icons/Person';
import { HiUserGroup } from 'react-icons/hi';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SettingsIcon from '@material-ui/icons/Settings';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import InsertChartIcon from '@material-ui/icons/InsertChart';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import PieChart from 'assets/img/icons/pie_chart';
// import PostAdd from '@material-ui/icons/PostAdd';
import PromoCode from '@material-ui/icons/LocalPlay';
import CreditType from '@material-ui/icons/LocalAtm';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { createSvgIcon } from '@material-ui/core';

function TaxRulesetIcon({ ...props }) {
  return (
    <svg width="24" height="24" {...props}>
      <path
        className="a"
        d="M-20972-19962h-16a2,2,0,0,1-2-2l.012-12a2,2,0,0,1,1.99-2h6l2,2h8a2,2,0,0,1,2,2v10A2,2,0,0,1-20972-19962Zm-5.41-5.275v0a1.966,1.966,0,0,0,1.707,1.775v1.006h1.391v-.994c1.033-.2,1.623-.8,1.623-1.645,0-1.3-1.1-1.764-2.182-2.043-1.014-.258-1.391-.529-1.391-1,0-.518.492-.854,1.254-.854.742,0,1.121.318,1.16.969h1.021a1.856,1.856,0,0,0-1.486-1.764v-1.018h-1.391v1a1.8,1.8,0,0,0-1.621,1.674c0,.953.689,1.563,2.174,1.918,1.227.289,1.393.727,1.393,1.117s-.328.826-1.25.826c-1.068,0-1.342-.531-1.385-.975h-1.018Z"
        transform="translate(20992.002 19981)"
      />
    </svg>
  );
}

function SKUIcon({ ...props }) {
  return (
    <svg width="24" height="24" {...props}>
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="M16.54 11L13 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L16.54 11zM11 7H2v2h9V7zm10 6.41L19.59 12 17 14.59 14.41 12 13 13.41 15.59 16 13 18.59 14.41 20 17 17.41 19.59 20 21 18.59 18.41 16 21 13.41zM11 15H2v2h9v-2z"></path>
    </svg>
  );
}

function RuleSetIcon({ ...props }) {
  return (
    <svg width="24" height="24" {...props}>
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM7.83 16L5 13.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L7.83 16zm9.58-3L19 14.59 17.59 16 16 14.41 14.41 16 13 14.59 14.59 13 13 11.41 14.41 10 16 11.59 17.59 10 19 11.41 17.41 13z"></path>
    </svg>
  );
}

function VehicleGroupIcon({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props}>
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path
        fillRule="evenodd"
        d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM10 17H5v-2h5v2zm0-4H5v-2h5v2zm0-4H5V7h5v2zm4.82 6L12 12.16l1.41-1.41 1.41 1.42L17.99 9l1.42 1.42L14.82 15z"
      ></path>
    </svg>
  );
}

function VehicleTypesIcon({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props}>
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="M14.17 13.71l1.4-2.42c.09-.15.05-.34-.08-.45l-1.48-1.16c.03-.22.05-.45.05-.68s-.02-.46-.05-.69l1.48-1.16c.13-.11.17-.3.08-.45l-1.4-2.42c-.09-.15-.27-.21-.43-.15l-1.74.7c-.36-.28-.75-.51-1.18-.69l-.26-1.85a.364.364 0 00-.35-.29h-2.8c-.17 0-.32.13-.35.3L6.8 4.15c-.42.18-.82.41-1.18.69l-1.74-.7c-.16-.06-.34 0-.43.15l-1.4 2.42c-.09.15-.05.34.08.45l1.48 1.16c-.03.22-.05.45-.05.68s.02.46.05.69l-1.48 1.16c-.13.11-.17.3-.08.45l1.4 2.42c.09.15.27.21.43.15l1.74-.7c.36.28.75.51 1.18.69l.26 1.85c.03.16.18.29.35.29h2.8c.17 0 .32-.13.35-.3l.26-1.85c.42-.18.82-.41 1.18-.69l1.74.7c.16.06.34 0 .43-.15zM8.81 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm13.11 7.67l-.96-.74c.02-.14.04-.29.04-.44 0-.15-.01-.3-.04-.44l.95-.74c.08-.07.11-.19.05-.29l-.9-1.55c-.05-.1-.17-.13-.28-.1l-1.11.45c-.23-.18-.48-.33-.76-.44l-.17-1.18a.216.216 0 00-.21-.2h-1.79c-.11 0-.21.08-.22.19l-.17 1.18c-.27.12-.53.26-.76.44l-1.11-.45a.23.23 0 00-.28.1l-.9 1.55c-.05.1-.04.22.05.29l.95.74a3.145 3.145 0 000 .88l-.95.74c-.08.07-.11.19-.05.29l.9 1.55c.05.1.17.13.28.1l1.11-.45c.23.18.48.33.76.44l.17 1.18c.02.11.11.19.22.19h1.79c.11 0 .21-.08.22-.19l.17-1.18c.27-.12.53-.26.75-.44l1.12.45c.1.04.22 0 .28-.1l.9-1.55c.06-.09.03-.21-.05-.28zm-4.29.16a1.35 1.35 0 11.001-2.701 1.35 1.35 0 01-.001 2.701z"></path>
    </svg>
  );
}

function InvoiceIcon({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props}>
      <rect fill="none" width="24" height="24" />
      <path d="M14,2H6A2,2,0,0,0,4.01,4L4,20a2,2,0,0,0,1.99,2H18a2.006,2.006,0,0,0,2-2V8Zm1,10H11v1h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H13v1H11V18H9V16h4V15H10a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1h1V9h2v1h2ZM13,8V3.5L17.5,8Z" />
    </svg>
  );
}

function BillingIcon({ ...props }) {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.5 1.5L15 0L13.5 1.5L12 0L10.5 1.5L9 0L7.5 1.5L6 0L4.5 1.5L3 0V14H0V17C0 18.66 1.34 20 3 20H15C16.66 20 18 18.66 18 17V0L16.5 1.5ZM16 17C16 17.55 15.55 18 15 18C14.45 18 14 17.55 14 17V14H5V3H16V17Z" />
      <path d="M12 5H6V7H12V5Z" />
      <path d="M15 5H13V7H15V5Z" />
      <path d="M12 8H6V10H12V8Z" />
      <path d="M15 8H13V10H15V8Z" />
    </svg>
  );
}

function PaymentIcon({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.814"
      height="21.814"
      viewBox="0 0 21.814 21.814"
      {...props}
    >
      <path fill="none" d="M0,0H21.814V21.814H0Z" />
      <path d="M17.212,12.634V5.727A1.77,1.77,0,0,0,15.411,4H2.8A1.77,1.77,0,0,0,1,5.727v6.907a1.77,1.77,0,0,0,1.8,1.727H15.411A1.77,1.77,0,0,0,17.212,12.634Zm-8.106-.863A2.644,2.644,0,0,1,6.4,9.18a2.644,2.644,0,0,1,2.7-2.59,2.644,2.644,0,0,1,2.7,2.59A2.644,2.644,0,0,1,9.106,11.771ZM20.814,6.59v9.5a1.77,1.77,0,0,1-1.8,1.727H3.7V16.088H19.013V6.59Z" />
    </svg>
  );
}

function DealerIcon({ className }) {
  return (
    <svg
      role="img"
      focusable="false"
      data-prefix="fas"
      aria-hidden="true"
      data-icon="handshake"
      viewBox="0 0 640 512"
      xmlns="http://www.w3.org/2000/svg"
      className={`svg-inline--fa fa-handshake fa-w-20 ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
      />
    </svg>
  );
}

const ChartIcon = () => (
  <svg width="20" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m19.165 1.6-.17 3.488a.795.795 0 0 1-.253.54.82.82 0 0 1-.56.22h-.057a.818.818 0 0 1-.549-.248.793.793 0 0 1-.223-.552l.057-1.184-4.729 5.432a.811.811 0 0 1-.601.272.742.742 0 0 1-.61-.248L7.596 5.28 2.143 9.36a.82.82 0 0 1-.496.16.823.823 0 0 1-.641-.312.791.791 0 0 1 .146-1.12L7.205 3.52a.822.822 0 0 1 1.089.088l3.753 3.92 4.242-4.872-1.325.2a.822.822 0 0 1-.589-.156.798.798 0 0 1-.298-.828.795.795 0 0 1 .37-.494.82.82 0 0 1 .298-.106l3.51-.52a.825.825 0 0 1 .666.2.8.8 0 0 1 .244.648Zm-1.04 13.656h-.813V9.6a.794.794 0 0 0-.238-.566.82.82 0 0 0-1.149 0 .794.794 0 0 0-.238.566v5.656h-2.794V12.8a.794.794 0 0 0-.239-.566.82.82 0 0 0-1.149 0 .794.794 0 0 0-.238.566v2.456H8.514V9.6a.794.794 0 0 0-.238-.566.819.819 0 0 0-1.149 0 .794.794 0 0 0-.238.566v5.656H4.134V12a.794.794 0 0 0-.238-.566.82.82 0 0 0-1.15 0A.794.794 0 0 0 2.51 12v3.256h-.862a.82.82 0 0 0-.574.234.794.794 0 0 0 0 1.132.82.82 0 0 0 .574.234h16.478a.82.82 0 0 0 .575-.234.794.794 0 0 0 0-1.132.82.82 0 0 0-.575-.234Z"
      fill="currentColor"
    />
  </svg>
);

const AccountStatementIcon = createSvgIcon(
  <>
    <path d="M19.5 3.5 18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H3v3c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2l-1.5 1.5zM19 19c0 .55-.45 1-1 1s-1-.45-1-1v-3H8V5h11v14z"></path>
    <path d="M9 7h6v2H9zm7 0h2v2h-2zm-7 3h6v2H9zm7 0h2v2h-2z"></path>
  </>,
  'AccountStatement Icon'
);

const NfcIcon = createSvgIcon(
  <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.27273 8.88889H20.4545V4.44444H2.27273V8.88889ZM20.4545 20C20.1326 20 19.8629 19.8933 19.6455 19.68C19.4273 19.4674 19.3182 19.2037 19.3182 18.8889V16.6667H17.0455C16.7235 16.6667 16.4538 16.56 16.2364 16.3467C16.0182 16.1341 15.9091 15.8704 15.9091 15.5556C15.9091 15.2407 16.0182 14.977 16.2364 14.7644C16.4538 14.5511 16.7235 14.4444 17.0455 14.4444H19.3182V12.2222C19.3182 11.9074 19.4273 11.6433 19.6455 11.43C19.8629 11.2174 20.1326 11.1111 20.4545 11.1111C20.7765 11.1111 21.0462 11.2174 21.2636 11.43C21.4818 11.6433 21.5909 11.9074 21.5909 12.2222V14.4444H23.8636C24.1856 14.4444 24.4553 14.5511 24.6727 14.7644C24.8909 14.977 25 15.2407 25 15.5556C25 15.8704 24.8909 16.1341 24.6727 16.3467C24.4553 16.56 24.1856 16.6667 23.8636 16.6667H21.5909V18.8889C21.5909 19.2037 21.4818 19.4674 21.2636 19.68C21.0462 19.8933 20.7765 20 20.4545 20ZM2.27273 17.7778C1.64773 17.7778 1.11288 17.5604 0.668182 17.1256C0.222727 16.69 0 16.1667 0 15.5556V2.22222C0 1.61111 0.222727 1.08815 0.668182 0.653333C1.11288 0.217778 1.64773 0 2.27273 0H20.4545C21.0795 0 21.6148 0.217778 22.0602 0.653333C22.5049 1.08815 22.7273 1.61111 22.7273 2.22222V8.88889H19.3182C17.7462 8.88889 16.4064 9.43037 15.2989 10.5133C14.1905 11.597 13.6364 12.9074 13.6364 14.4444V17.7778H2.27273Z"
      fill="currentColor"
    />
  </svg>,
  'NFC Icon'
);

const routes = [
  {
    children: [{ label: 'dashboard', icon: HomeIcon, path: '/dashboard' }],
  },
  {
    title: 'operations',
    children: [
      {
        label: 'reservations',
        icon: DescriptionIcon,
        path: '/reservations',
        privilege: {
          do: 'read',
          on: 'reservation',
        },
        configuration: {
          name: 'reservation',
          is: 'enabled',
        },
      },
      {
        label: 'subscriptions',
        icon: DescriptionIcon,
        path: '/subscriptions',
        privilege: {
          do: 'read',
          on: 'subscription',
        },
        configuration: {
          name: 'subscription',
          is: 'enabled',
        },
      },
      {
        label: 'customers',
        icon: GroupIcon,
        path: '/customers',
        privilege: {
          do: 'customer_access',
          on: 'user',
        },
        configuration: {
          name: 'user',
          is: 'driver_allowed',
        },
      },
      {
        icon: DealerIcon,
        label: 'dealers',
        path: '/dealers',
        privilege: {
          do: 'read',
          on: 'user_group',
        },
        configuration: {
          name: 'organization',
          is: 'b2b',
        },
      },
      {
        icon: AttachFileOutlinedIcon,
        label: 'documents',
        path: '/documents',
        privilege: {
          do: 'read',
          on: 'document',
        },
      },
      {
        icon: LibraryBooksIcon,
        label: 'document_types',
        path: '/document-types',
        privilege: {
          do: 'read',
          on: 'document_type',
        },
      },
      {
        icon: NfcIcon,
        label: 'nfc',
        path: '/NFC',
        privilege: {
          do: 'read',
          on: 'access_device',
        },
        configuration: {
          name: 'access_device',
          is: 'nfc_allowed',
        },
      },
    ],
  },
  {
    title: 'vehicle_management',
    children: [
      {
        icon: DriveEtaIcon,
        label: 'vehicles',
        path: '/vehicles',
        privilege: {
          do: 'read',
          on: 'vehicle',
        },
        configuration: {
          name: 'vehicle',
          is: 'enabled',
        },
      },
      {
        icon: VehicleTypesIcon,
        label: 'vehicle_types',
        path: '/vehicle-types',
        privilege: {
          do: 'create_allowed',
          on: 'vehicle_type',
        },
        organizationType: ['msOwnerOrg', 'plainOrg'],
      },
    ],
  },
  {
    title: 'location_management',
    children: [
      {
        icon: MapIcon,
        label: 'locations',
        path: '/locations',
        privilege: {
          do: 'create',
          on: 'location',
        },
        configuration: {
          name: 'location',
          is: 'enabled',
        },
        organizationType: ['msOwnerOrg', 'plainOrg'],
      },
      {
        icon: RoomIcon,
        label: 'fleets',
        path: '/fleets',
        privilege: {
          do: 'read',
          on: 'vehicle_group',
        },
        organizationType: 'msOwnerOrg',
      },
      {
        icon: VehicleGroupIcon,
        label: 'vehicles_groups',
        path: '/service-groups',
        privilege: {
          do: 'read',
          on: 'vehicle_group',
        },
        organizationType: ['msServiceOrg', 'plainOrg'],
      },
      {
        icon: ScheduleIcon,
        label: 'business_hours',
        path: '/business-hours',
        configuration: {
          name: 'reservation',
          is: 'enabled',
        },
        privilege: {
          do: 'read',
          on: 'business_hours_rules_set',
        },
        organizationType: ['msServiceOrg', 'plainOrg'],
      },
    ],
  },
  {
    title: 'tools',
    children: [
      {
        icon: NotificationsActiveIcon,
        label: 'alarms',
        path: '/alarms',
        privilege: {
          do: 'read',
          on: 'conditional_instance',
        },
        configuration: {
          name: 'alarm',
          is: 'enabled',
        },
      },
      {
        icon: AssignmentTurnedInIcon,
        label: 'tasks',
        path: '/tasks',
        privilege: {
          do: 'read',
          on: 'task',
        },
        configuration: {
          name: 'task',
          is: 'enabled',
        },
      },
    ],
  },
  {
    title: 'billing',
    children: [
      {
        icon: BillingIcon,
        label: 'billing',
        path: '/billing',
        privilege: {
          do: 'list',
          on: 'invoice',
        },
        configuration: {
          name: 'invoice',
          is: 'enabled',
        },
        receivableType: 'billing',
      },
      {
        icon: InvoiceIcon,
        label: 'invoices',
        path: '/invoices',
        privilege: {
          do: 'list',
          on: 'invoice',
        },
        configuration: {
          name: 'invoice',
          is: 'enabled',
        },
        sharingType: 'FAAS',
        receivableType: 'invoice',
      },
      {
        icon: InvoiceIcon,
        label: 'statement_entries',
        path: '/statement-entries',
        privilege: {
          do: 'read',
          on: 'account_statement',
        },
        configuration: {
          name: 'account_statement',
          is: 'enabled',
        },
        sharingType: 'FFB',
        receivableType: 'statement',
      },
      {
        icon: PaymentIcon,
        label: 'payments',
        path: '/payments',
        privilege: {
          do: 'list',
          on: 'payment',
        },
        configuration: {
          name: 'payment',
          is: 'enabled',
        },
      },
      {
        icon: AccountStatementIcon,
        label: 'account_statement',
        path: '/account-statement',
        privilege: {
          do: 'read',
          on: 'account_statement',
        },
        configuration: {
          name: 'account_statement',
          is: 'enabled',
        },
      },
    ],
  },
  {
    title: 'pricing',
    children: [
      {
        icon: SKUIcon,
        label: 'skus',
        path: '/skus',
        privilege: {
          do: 'read',
          on: 'invoice_item_type',
        },
        configuration: {
          name: 'pricing',
          is: 'invoice_item_types',
        },
      },
      {
        icon: RuleSetIcon,
        label: 'pricing_rulesets',
        path: '/pricing-rulesets',
        privilege: {
          do: 'read',
          on: 'pricing_rule_set',
        },
        configuration: {
          name: 'pricing',
          is: 'pricing_rules_set',
        },
      },
      {
        icon: TaxRulesetIcon,
        label: 'tax_rulesets',
        path: '/tax-rulesets',
        privilege: {
          do: 'read',
          on: 'tax_rules_set',
        },
        configuration: {
          name: 'pricing',
          is: 'enabled',
        },
        configRenderer: {
          selector: 'pricing.tax_rules_set.enabled',
          subject: true,
        },
      },
      {
        icon: CreditType,
        label: 'credit_types',
        path: '/credit-types',
        configuration: {
          name: 'pricing',
          is: 'credits',
        },
        privilege: {
          do: 'create',
          on: 'credit',
        },
      },
      {
        icon: PromoCode,
        label: 'promo_codes',
        path: '/promo-codes',
        privilege: {
          do: 'read',
          on: 'promotional_code',
        },
        configuration: {
          name: 'pricing',
          is: 'promotional_codes',
        },
        organizationType: ['msServiceOrg', 'plainOrg'],
      },
    ],
  },
  {
    title: 'organization',
    children: [
      {
        icon: GroupWorkIcon,
        label: 'partners',
        path: '/partners',
        privilege: {
          do: 'read',
          on: 'org_to_org_access',
        },
        configuration: {
          name: 'partnership',
          is: 'enabled',
        },
      },
      {
        icon: NotificationsIcon,
        label: 'notifications',
        path: '/notifications',
        privilege: {
          do: 'read',
          on: 'org_to_org_access',
        },
        configuration: {
          name: 'partnership',
          is: 'enabled',
        },
        sharingType: 'FAAS',
      },
      {
        icon: PersonIcon,
        label: 'users',
        path: '/employees',
        privilege: {
          do: 'read',
          on: 'peer',
        },
      },
      {
        icon: RuleSetIcon,
        label: 'reservation_rulesets',
        path: '/reservation-rulesets',
        accessControl: [
          'privilege.reservation_rules_set.read',
          'OR',
          'privilege.reservation_rules_set.update_multiple_buffer',
          'AND',
          'configuration.reservation.enabled.true',
        ],
      },
      {
        icon: HiUserGroup,
        label: 'users_groups',
        path: '/users-groups',
        privilege: {
          do: 'read',
          on: 'user_group',
        },
      },
      {
        icon: WorkIcon,
        label: 'organization_settings',
        path: '/general-information',
        privilege: {
          do: 'read',
          on: 'peer',
        },
      },
      {
        icon: SettingsIcon,
        label: 'configuration',
        path: '/configuration',
        privilege: {
          do: 'update',
          on: 'organization_config',
        },
      },
    ],
  },
  {
    title: 'reports',
    children: [
      {
        label: 'legacy-reports',
        path: '/legacy-reports',
        icon: InsertChartIcon,
        configuration: {
          name: 'reporting',
          is: 'template_enabled',
        },
        privilege: {
          do: 'read',
          on: 'report_template',
        },
      },
      {
        label: 'reporting',
        path: '/reporting',
        icon: PieChart,
        configuration: {
          name: 'analytics',
          is: 'template_enabled',
        },
        privilege: {
          do: 'read',
          on: 'report_template',
        },
      },
      {
        label: 'charts',
        path: '/charts',
        icon: ChartIcon,
        configuration: {
          name: 'analytics',
          is: 'template_enabled',
        },
        privilege: {
          do: 'read',
          on: 'report_template',
        },
      },
    ],
  },
  {
    title: 'settings',
    children: [
      {
        label: 'authentication',
        path: '/authentication',
        icon: FingerprintIcon,
        configRenderer: {
          selector: 'auth.fusion_auth_config.settings.enabled',
          subject: true,
        },
        privilege: {
          do: 'settings',
          on: 'auth',
        },
      },
      {
        icon: DeviceHubIcon,
        label: 'organization_brokers',
        path: '/brokers',
        privilege: {
          do: 'update',
          on: 'organization_brokers',
        },
      },
    ],
  },
  // {
  //   label: "kpis",
  //   icon: TimelineIcon,
  //   privilege: {
  //     do: "read",
  //     on: "report",
  //   },
  //   configuration: {
  //     name: "reporting",
  //     is: "enabled",
  //   },
  // },
  // {
  //   label: "subscriptions",
  //   icon: InsertDriveFileIcon,
  //   path: "/subscriptions",
  //   configuration: {
  //     name: "subscription",
  //     is: "enabled",
  //   },
  // },
];

DealerIcon.propTypes = {
  className: PropTypes.string,
};

export default routes;
